import React, { useState } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

export function OptionalTooltip({ visible, children, ...otherProps }: TooltipProps & { readonly visible: boolean }) {
  const [open, setOpen] = useState(false);

  if (open && !visible) setOpen(false);

  return (
    <Tooltip
      disableInteractive
      open={open && visible}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      {...otherProps}
    >
      <span>{children}</span>
    </Tooltip>
  );
}
